import { Company, Profile } from 'app/models';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  DeactivatedUsersService,
  SnackBarService,
  UsersService,
} from 'app/services';

import { ConfirmDeleteDialogComponent } from '../../dialogs';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SnackbarType } from 'app/constants/Enums';
import { TranslateService } from '@ngx-translate/core';
import { UserDialogComponent } from '../../users/user-dialog/user-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { MatSort } from '@angular/material/sort';
import { environment } from 'environments/environment';
@Component({
  standalone: false,
  selector: 'app-company-users',
  templateUrl: './company-users.component.html',
  styleUrls: ['./company-users.component.scss'],
})
export class CompanyUsersComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input()
  companyId: string;
  @Input()
  usersProfile: Subject<any[]>;
  @Input()
  companyBranches: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort

  branches: Company[];
  branchAdmins: Set<string> = new Set<string>();
  users: Profile[] = [];
  selectedUsers = new SelectionModel<Profile>(true, []);
  userList: MatTableDataSource<Profile>;
  usersError: string;
  queryString: string = "";
  noRecordFound: boolean;
  currentPageUsers: Profile[];
  message = 'No_Company_User_Found';
  displayedColumns = ['select', 'name', 'email', 'branches'];


  private onDestroy$ = new Subject<void>();
  constructor(
    private _usersService: UsersService,
    private _router: Router,
    private _deactivatedUsersService: DeactivatedUsersService,
    private _translateService: TranslateService,
    private _dialog: MatDialog,
    private _snackbarService: SnackBarService
  ) { }

  ngOnInit() {
    if (this.companyId) {
      this._usersService.loading = true;
    }
    this.usersProfile.pipe(takeUntil(this.onDestroy$)).subscribe((users) => {
      if (users) {
        users.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );

        this.users = users;
        this.userList = new MatTableDataSource(users);
        this.userList.paginator = this.paginator;
        this.userList.sort = this.sort;
        this.userList.sortingDataAccessor = tableHelpers.sortingDataAccessor;

        this.userList
          .connect()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((usersList) => {
            this.currentPageUsers = usersList;
          });
        this.updateBranchAdmin();
        this.monitorSearch(this.queryString);
        this._usersService.loading = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.companyBranches.currentValue) {
      this.updateBranchAdmin();
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  updateBranchAdmin(){
    this.branches = this.companyBranches;
      this.branchAdmins = new Set<string>();

      if(this.branches){
        this.branches.forEach(branch => {
          if (branch.branchAdmins && branch.branchAdmins.length > 0) {
            branch.branchAdmins.forEach(admin => {
              this.branchAdmins.add(admin);
            });
          }
        });
      }
      
  }

  monitorSearch(event) {
    this.queryString = event.trim();
    if (this.queryString.trim().length >= Number(environment.minimumSearchLength)) {
      this.userList.data = this.users;
      this.userList.data = this.userList.data.filter(
        (a) =>
          a['name'].toUpperCase().includes(this.queryString.toUpperCase()) ||
          a['email'].toUpperCase().includes(this.queryString.toUpperCase())
      );
      this.noRecordFound = this.userList.data.length === 0;
    } else {
      this.userList.data = this.users;
      this.noRecordFound = false;
    }
  }

  selectedRecords(user) {
    this.selectedUsers.toggle(user);
  }

  public handleNavigate(user) {
    this._router.navigate(['/company/users', user.id, this.companyId]);
  }

  openUserProfile(selectedUser) {
    const dialog = this._dialog.open(UserDialogComponent, {
      disableClose: true,
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      width: '880px',
      data: {
        user: selectedUser,
      },
    });
    dialog.afterClosed().subscribe((result) => { });
  }

  handleRowClick(user) {
    if(!user.name){
      user.name = `${user.firstName} ${user.lastName}`;
    }
    this.openUserProfile(user);
  }

  confirmDeactivate(): void {
    // translate strings
    let deactivateMessage;
    this._translateService
      .get('COMPANY_DELETE_USERS.no_users_warning')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (deactivateMessage = value));
    let title;
    this._translateService
      .get('COMPANY_DELETE_USERS.deactivate_users_confirmation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (title = value));

    let blockUser = '';
    this._translateService
      .get('SNACKBAR.block_user')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (blockUser = value));

    let block = '';
    this._translateService
      .get('SNACKBAR.block_user')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => (block = value));

    const usersToDeactivate: any = this.selectedUsers.selected;
    if (usersToDeactivate.length === 0) {
      this._snackbarService.showSnackbar(
        SnackbarType.info,
        blockUser,
        deactivateMessage
      );
      return;
    } else if (usersToDeactivate.findIndex((user) => user.isInvite) !== -1) {
      return;
    }
    const dialog = this._dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      autoFocus: false,
      data: {
        users: this.selectedUsers.selected,
        buttonText: block,
        title,
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.selectedUsers.clear();
        const userIds = usersToDeactivate.map((user) => user.id);

        this._deactivatedUsersService.deactivateUsers(userIds, this.companyId);
      }
    });
  }

  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageUsers, this.selectedUsers.selected);

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = () => tableHelpers.masterToggle(this.currentPageUsers, this.selectedUsers);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageUsers, this.selectedUsers.selected);

  isBranchAdmin(user){
    return !user.isCompanyAdmin && this.branchAdmins.has(user.id);
  }
}
